export default {
  dynamics: '{{change}} rispetto alla settimana precedente',
};
